import React, { useState, useEffect, Fragment } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Button, Spinner, Col, Row, Form, FormGroup, Label, Input, Alert,
    Nav, NavItem, NavLink, TabContent, TabPane, CustomInput,
    Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, FormText, Container } from 'reactstrap';
import { Prompt, NavLink as RouterNavLink, Link } from 'react-router-dom';
// @ts-ignore
import Select from 'react-select';

export default function ResetPasswordForm({props, read, save, remove }: any) {
  
  const [userStatus, setUserStatus] = useState("Approved");
  const [removeWarning, setRemoveWarning] = useState(false);
  const toggleRemoveWarning = () => setRemoveWarning(!removeWarning);

  const [eTag, setETag] = useState(""); // Detect changes on data
  const [isSaved, setIsSaved] = useState(false);

  const { register, handleSubmit, reset, watch, errors, formState, control  } = useForm();
  
  // Read the formState before render to subscribe the form state through Proxy
  const { dirty, isSubmitting, isSubmitted, touched, submitCount } = formState;
  
  const onSubmit = (data : any, e: any) => {
    //console.log(data)
    save(data);
    setIsSaved(true);
  };

  const watchFields = watch(["_etag"]);
  if (watchFields){
      if (watchFields._etag !== undefined && props.data?._etag !== undefined && (eTag === "" || eTag != props.data?._etag)){
        setETag(props.data._etag);
        //console.log("_etag updated..." + props.data._etag);
        if (isSaved){ // Reset only if record updated and issubmitted
            //console.log("Call Reset");
            setTimeout(() => {
                reset();
                setIsSaved(false);
            }, 0)
            
        }
      }
  }

  const handleRequestDelete = () => {
    remove(props.data);
    setRemoveWarning(!removeWarning);
  }
  
  const handleReloadData = () => {
    read();
  }
  
  // console.log(errors);
  // {errors}

  const handleSelectedOption = (optionList: any, name: string) => {
    let index = optionList.map(function(e:any) { 
        return e.value; 
    }).indexOf(name);

    if (index !== -1) {
        return optionList[index];
    }
  }
  const handleSelectOnChange = (target: any, event: any) => {
    if (target) {
        setUserStatus(target.value);
    }
  }
  
  const userStatusOptions = [
    { value: 'Approved', label: 'Approved' },
    { value: 'Pending Approval', label: 'Pending Approval' },
    { value: 'De-Activated', label: 'De-Activated' }
  ];


  return (
      <Fragment>
        <Form id='ResetPasswordFrom' className="mt-3 mb-3" onSubmit={handleSubmit(onSubmit)}>
            <FormGroup row={true}>
                <Label for="fullName" sm={2}>Name</Label >
                <Col lg={6} sm={10}>
                    <Input type="text" name="fullName" defaultValue={props.data?.fullName} 
                        innerRef={register({ required: true, minLength:10 })} readOnly={true} />
                    {errors.fullName && <FormText color="danger">Required field. Minimum length 10 character.</FormText>}
                </Col>
            </FormGroup>
            <FormGroup row={true}>
                <Label for="newPassword" sm={2}>New Password</Label >
                <Col lg={3} sm={3}>
                    <Input type="password" name="newPassword"
                        innerRef={register({ required: true, minLength:6 })} />
                    {errors.newPassword && <FormText color="danger">Required field. Minimum length 6 character.</FormText>}
                </Col>
            </FormGroup>
            <FormGroup row={true}>
                <Label for="confirmNewPassword" sm={2}>Confirm New Password</Label >
                <Col lg={3} sm={3}>
                    <Input type="password" name="confirmNewPassword"
                        innerRef={register({ required: true, minLength:6 })} />
                    {errors.confirmNewPassword && <FormText color="danger">Required field. Minimum length 6 character.</FormText>}
                </Col>
            </FormGroup>

            <Input type="hidden" name="userOId" defaultValue={props.data?.id}  innerRef={register()} />
            <Input type="hidden" name="_etag" defaultValue={props.data?._etag}  innerRef={register()} />

            <FormGroup row={true}>
                <Col sm={12}>
                    <Button type="submit" color="danger" size="lg" className="float-right" disabled={!dirty || props.ui.loading || props.ui.processing} >
                        <i className="fas fa-save mr-1"></i>&nbsp;Reset
                    </Button>
                    {
                        props.ui.processing && (<Spinner color="warning" className="float-right">&nbsp;</Spinner>)
                    }   
                </Col>
            </FormGroup>
            <Modal isOpen={removeWarning} toggle={toggleRemoveWarning} >
                <ModalHeader toggle={toggleRemoveWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Please confirm to remove this record<br/>
                        Note. This action is irreversible.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <Button color="danger" size="lg" onClick={handleRequestDelete}>
                        <i className="fas fa-trash-alt mr-1"></i>&nbsp; Proceed to Remove
                    </Button>
                    <Button color="secondary" size="lg" onClick={toggleRemoveWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            <Modal isOpen={props.ui.processState === 3} backdrop="static" keyboard={false} >
                <ModalHeader>Success</ModalHeader>
                <ModalBody>
                    <p>Succesfully remove!<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <RouterNavLink to="/users" className="nav-link" exact>
                        <i className="fas fa-list mr-1"></i>Back to User List
                    </RouterNavLink>
                </ModalFooter>
            </Modal> 
        </Form>
        <br/><br/>
        <br/>
        {/* <Row>
            <Col lg="12">
                {JSON.stringify(props.data)}
            </Col>
        </Row> */}
        <Prompt when={dirty && !isSubmitted} 
            message="Are you sure want to discard your changes?"
        />
    </Fragment>
    
  );
}